import * as yup from 'yup';

export const schemaValidate = yup.object().shape({
  code: yup
    .string()
    .trim()
    .required('確認コードを入力してください。')
    .matches(/^[0-9]{6}$/, '確認コードは6桁の数字で入力してください。'),
});
